/**
 * ForStraction service API
 * Lead your organisation’s full potential to creating results
 *
 * OpenAPI spec version: 2.0.1639219082
 * 
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

(function(root, factory) {
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['ApiClient', 'model/MeetingTemplateSectionTextTopic', 'model/MeetingTemplateSectionTopicLink'], factory);
  } else if (typeof module === 'object' && module.exports) {
    // CommonJS-like environments that support module.exports, like Node.
    module.exports = factory(require('../ApiClient'), require('./MeetingTemplateSectionTextTopic'), require('./MeetingTemplateSectionTopicLink'));
  } else {
    // Browser globals (root is window)
    if (!root.ForStractionServiceApi) {
      root.ForStractionServiceApi = {};
    }
    root.ForStractionServiceApi.MeetingTemplateSectionTopicReport = factory(root.ForStractionServiceApi.ApiClient, root.ForStractionServiceApi.MeetingTemplateSectionTextTopic, root.ForStractionServiceApi.MeetingTemplateSectionTopicLink);
  }
}(this, function(ApiClient, MeetingTemplateSectionTextTopic, MeetingTemplateSectionTopicLink) {
  'use strict';




  /**
   * The MeetingTemplateSectionTopicReport model module.
   * @module model/MeetingTemplateSectionTopicReport
   * @version 2.0.1639219082
   */

  /**
   * Constructs a new <code>MeetingTemplateSectionTopicReport</code>.
   * @alias module:model/MeetingTemplateSectionTopicReport
   * @class
   */
  var exports = function() {
    var _this = this;







  };

  /**
   * Constructs a <code>MeetingTemplateSectionTopicReport</code> from a plain JavaScript object, optionally creating a new instance.
   * Copies all relevant properties from <code>data</code> to <code>obj</code> if supplied or a new instance if not.
   * @param {Object} data The plain JavaScript object bearing properties of interest.
   * @param {module:model/MeetingTemplateSectionTopicReport} obj Optional instance to populate.
   * @return {module:model/MeetingTemplateSectionTopicReport} The populated <code>MeetingTemplateSectionTopicReport</code> instance.
   */
  exports.constructFromObject = function(data, obj) {
    if (data) {
      obj = obj || new exports();

      if (data.hasOwnProperty('TextTopic')) {
        obj['TextTopic'] = MeetingTemplateSectionTextTopic.constructFromObject(data['TextTopic']);
      }
      if (data.hasOwnProperty('TopicLink')) {
        obj['TopicLink'] = MeetingTemplateSectionTopicLink.constructFromObject(data['TopicLink']);
      }
      if (data.hasOwnProperty('SectionID')) {
        obj['SectionID'] = ApiClient.convertToType(data['SectionID'], 'Integer');
      }
      if (data.hasOwnProperty('ContentTypeID')) {
        obj['ContentTypeID'] = ApiClient.convertToType(data['ContentTypeID'], 'Integer');
      }
      if (data.hasOwnProperty('Sort')) {
        obj['Sort'] = ApiClient.convertToType(data['Sort'], 'Integer');
      }
      if (data.hasOwnProperty('ID')) {
        obj['ID'] = ApiClient.convertToType(data['ID'], 'Integer');
      }
    }
    return obj;
  }

  /**
   * @member {module:model/MeetingTemplateSectionTextTopic} TextTopic
   */
  exports.prototype['TextTopic'] = undefined;
  /**
   * @member {module:model/MeetingTemplateSectionTopicLink} TopicLink
   */
  exports.prototype['TopicLink'] = undefined;
  /**
   * @member {Integer} SectionID
   * @default 0
   */
  exports.prototype['SectionID'] = 0;
  /**
   * @member {Integer} ContentTypeID
   * @default 0
   */
  exports.prototype['ContentTypeID'] = 0;
  /**
   * @member {Integer} Sort
   * @default 0
   */
  exports.prototype['Sort'] = 0;
  /**
   * @member {Integer} ID
   * @default 0
   */
  exports.prototype['ID'] = 0;



  return exports;
}));


